module.exports = __webpack_public_path__ + "files/bb569fc44808357e8e0c1bdfa19ce5ca.png";